import React from 'react';
import '../legalDoc.scss';

/**
 * Disclaimer. Text is verbatim from Laravel's disclaimer.blade.php, which is also
 * byte-identical to what facilonservices.co.in/disclaimer publishes (checked 2026-09-12).
 *
 * Until now /disclaimer rendered the Service Agreement, so investors following the
 * footer link were shown the wrong document.
 */
export const Disclaimer: React.FC = () => {
  return (
    <div>
      <div className="bg-white border-b border-slate-200 py-2 px-6 flex items-center">
        <img src="/assets/images/logo.png" alt="Facilon" style={{ height: 40, objectFit: 'contain' }} />
      </div>
      <div className="public-page bg-slate-50 py-8 min-h-screen">
        <div className="container max-w-5xl mx-auto px-4 space-y-6">
          <div className="bg-[#052f55] p-6 rounded-xl shadow-sm">
            <h1 className="text-2xl font-bold m-0 flex items-center gap-2 text-white" style={{ color: '#ffffff' }}>
              <i className="bi bi-exclamation-triangle-fill text-red-500"></i>
              <span>Disclaimer</span>
            </h1>
            <p className="text-slate-300 text-xs mt-1 mb-0">
              The basis on which Facilon provides the platform and its information.
            </p>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-xs legal-doc">
            <p>
              Facilon acts strictly as a facilitator of information and document exchange between
              relevant parties and does not provide financial, investment, legal, tax, or regulatory
              advice and does not act as a broker, distributor, investment advisor, portfolio manager,
              custodian, intermediary, or fiduciary.
            </p>
            <p>
              Nothing contained herein constitutes an offer, solicitation, recommendation, endorsement,
              or promotion of any investment, security, financial product, or service.
            </p>
            <p>
              Any reference to, or listing of, service providers is provided solely for informational
              and operational convenience. Such listing does not constitute and shall not be interpreted
              as a recommendation, endorsement, ranking, approval, or preference by Facilon of any
              specific service provider, their services, investment products, securities, or performance.
              Users remain solely responsible for independently evaluating and selecting any service
              provider.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
